import { APIObject } from '@/shared/plugins/Api/API'
import _omit from 'lodash/omit'


class SnapshotTimeTravel extends APIObject {
  constructor (options, parent) {
    super('DM', options, parent)
    this._parent = parent
    this.id = this.sequence_number // Use sequence_number as id since it is unique
    this.snapshot_id = this.snapshot_id || '' // This snapshot_id is not always unique
    this.versionStatus = this.getVersionStatus()
  }

  getVersionStatus () {
    let versionStatus = ''
    const snapshotList = this._parent.history.filter(s => s.snapshot_id === this._parent.currentSnapshotId)
    if (snapshotList.length === 0) return versionStatus
    // To define which snapshot is the current version,
    // we need to compare with the latest snapshot that has same snapshot_id since the snapshot_id is not always unique
    const currentSnapshot = snapshotList.sort((a, b) => b.timestamp_ms - a.timestamp_ms)[0]
    // id and sequence_number are the same as it is defined in the constructor
    if (this.id === currentSnapshot.sequence_number) versionStatus = 'current'
    else if (this.is_rollback) versionStatus = 'rollback'
    else if (this.snapshot_id) versionStatus = 'parent'
    return versionStatus
  }

  _filter (object) {
    const obj = _omit(super._filter(object), [
      '_id',
      '__socketId',
      'created_at',
      'updated_at',
      'created_by',
      'updated_by'
    ])
    return obj
  }

  async revert (params = {}) {
    return await this.request({
      method: 'post',
      url: `v4/databases/${params.databaseId}/tables/${params.tableId}/rollback`,
      params: {
        snapshot_id: this.snapshot_id
      }
    })
  }
}

export {
  SnapshotTimeTravel
}
